import { SVGProps } from '@components/Icon/types';

export const InfoSquareFilled = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(22, 22) scale(-1, -1)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.81 0H14.19C17.83 0 20 2.17 19.99 5.81V14.19C19.99 17.83 17.82 20 14.18 20H5.81C2.17 20 0 17.83 0 14.18V5.81C0 2.17 2.17 0 5.81 0ZM9.99023 5.25C9.58023 5.25 9.24023 5.59 9.24023 6V11C9.24023 11.41 9.58023 11.75 9.99023 11.75C10.4002 11.75 10.7402 11.41 10.7402 11V6C10.7402 5.59 10.4002 5.25 9.99023 5.25ZM10.7002 14.71C10.7902 14.61 10.8602 14.51 10.9102 14.38C10.9602 14.26 10.9902 14.13 10.9902 14C10.9902 13.87 10.9602 13.74 10.9102 13.62C10.8602 13.5 10.7902 13.39 10.7002 13.29C10.6002 13.2 10.4902 13.13 10.3702 13.08C10.1302 12.98 9.85023 12.98 9.61023 13.08C9.49023 13.13 9.38023 13.2 9.28023 13.29C9.19023 13.39 9.12023 13.5 9.07023 13.62C9.02023 13.74 8.99023 13.87 8.99023 14C8.99023 14.13 9.02023 14.26 9.07023 14.38C9.12023 14.51 9.19023 14.61 9.28023 14.71C9.38023 14.8 9.49023 14.87 9.61023 14.92C9.73023 14.97 9.86023 15 9.99023 15C10.1202 15 10.2502 14.97 10.3702 14.92C10.4902 14.87 10.6002 14.8 10.7002 14.71Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'info-square-filled';
